import React from 'react';
import { styled } from '@mui/material';
import { Label } from './Label';

interface FieldGroupProps {
    label: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export function FieldGroup({ label, children, style }: FieldGroupProps) {
    return (
        <Group style={style}>
            <Label>{label}</Label>
            {children}
        </Group>
    );
}

const Group = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
});
